export const DEFAULT_DISCOUNT = "0";
